import { LocationGroup } from 'src/app/core/models/admin/location-admin.model';

export const CONSTANTS = {
  UNASSIGN_BUTTON_TEXT: $localize`Unassign`,
  ASSIGN_BUTTON_TEXT: $localize`Assign`,
  SEARCH_PLACEHOLDER: $localize`Search Here`,
};

export type TwoColumnFormData = {
  data: LocationGroup;
  selected: boolean;
};
